<template>
  <div class="eval" id="eval">
    <!-- 我的测评 -->
    <div class="content">
      <div v-if="status == 1">
        <p class="title">提交要求：</p>
        <p class="title">{{config.reportTitle}}</p>
        <img class="sumup_ok" src="../../assets/images/sumup_ok.png" alt="">
      </div>
      <div v-if="status == 0">
        <p class="title">提交要求：</p>
        <p class="title" >{{config.reportTitle}}</p>
        <div class="input">
          <a :href="uploaded.url" style="text-decoration: none;">
            <div class="type1" v-if="!canUpload && uploaded">
              <div class="doc">
                <img src="../../assets/images/sumup_doc.png" alt="">
                <span>{{fileName}}</span>
              </div>
              <p class="sure" style="color: red;font-size: 25px">{{checkStatus}}</p>
              <el-progress type="circle" :percentage="percentage" v-show="percentage > 0"></el-progress>
              <span v-if="reUpload" class="again" @click="removeUpload">重新上传</span>
              <p class="sure" v-if="levelstatus==4" style="color: red;font-size: 20px">优秀</p>
              <p class="sure" v-if="levelstatus==2" style="color: red;font-size: 20px">合格</p>
              <!-- <p class="sure">提交后无法修改</p> -->
              <!-- <span class="again" @click="removeUpload">重新上传</span> -->
            </div>
          </a>


          <div class="type1" v-if="!canUpload && (!uploaded)">
            <div class="doc">
              <img src="../../assets/images/sumup_doc.png" alt="">
              <span>{{fileName}}</span>
            </div>
            <!-- <p class="sure">资料已提交</p> -->
            <p class="sure"  style="color: red;font-size: 25px">{{checkStatus}}</p>
            <el-progress type="circle" :percentage="percentage" v-show="percentage > 0"></el-progress>
            <span class="again" @click="removeUpload">重新上传</span>

          </div>

          <div v-if="canUpload">
            <el-upload
              class="upload-file"
              accept=".ppt, .pptx,.doc,.docx,.pdf,.rar,.zip"
              :action="doUpload"
              :headers="Headers"
              :on-change="handleChange"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :show-file-list="false"
              :http-request="cosUploadFile"
              ref="newupload"
              multiple
              drag
              :auto-upload="false">
              <div class="type2">
                <img class="upload" src="../../assets/images/sumup_up.png" alt="">
                <p class="tip">点击或将文件拖拽到这里上传</p>
                <p class="tips">支持扩展名：{{config.fileExt}}</p>
              </div>
            </el-upload>
          </div>
        </div>
        <!--  <div class="btn" @click="toStudy" style="margin-top: 1.5rem;" v-if="!canUpload && (!uploaded)">确认提交</div>-->

      </div>
    </div>
    <div class="masking">

    </div>
  </div>
</template>

<script>
  import {
    uploadFile
  } from '@/assets/js/uploadfile'
  export default {
    name: 'sumup',
    data () {
      return {
        config:{},
        status:0,
        fileName:'',
        fileBase64:'',
        Headers:{},
        uploaded:'',
        doUpload:'',
        levelstatus:0,
        checkStatus: '审核中',
        canUpload:true,
        reUpload:false,
        file:'',
        url:'',
        uploadComponent:'',
        percentage:0,
        path: '/trainingfile/file_2022',
      }
    },
    mounted() {
      var _this = this;
      this.event = JSON.parse(localStorage.getItem('event'));
      this.config = JSON.parse(localStorage.getItem('config'));
      // _this.Headers = {
      //   'access-token':localStorage.getItem('token'),
      //   'source':0,
      // }
      this.doUpload = this.url_post+'/reportFile/fileUpload'+'?access-token='+localStorage.getItem('token')+'&eventId='+this.event.eventId
      this.getUploaded();
    },
    methods:{
      prevFile(){

      },
      getUploaded(){
        var _this = this;
        this.post('/reportFile/fileInfo',{eventId:this.event.eventId,},(data)=>{
          // console.log(data);
          console.log(data.data);
          if(data.status == 200){
            if(data.data.status > 0){

              if (data.data.status===2){
                _this.checkStatus = "审核通过";
              }
              if (data.data.status===3){
                _this.checkStatus = "审核未通过,请重新上传";
                _this.reUpload=true;
              }
              _this.canUpload = false;
              _this.uploaded = true;
              _this.fileName = data.data.name;
            }else if(data.data.status == 0 && data.data.url){
              _this.canUpload = false;
              _this.uploaded = false;
              _this.fileName = data.data.name;
            }else if(!data.data.url && data.data.status == 0){
              _this.canUpload = true;
              _this.uploaded = true;
            }
            if (data.data.status==4) {
              _this.checkStatus = "审核通过";
              _this.levelstatus=4
            }else {
              _this.levelstatus=data.data.status
            }
          }
        })
      },
      removeUpload(){
        this.canUpload = true;
        this.fileName = '';
      },
      handleSuccess(e){
        var _this = this;
        console.log(e);
        _this.$mResToast({
          type:e.status == 200 ? 'success' : 'error',
          msg:e.msg,
          duration:3000,
          isIcon:true,
        });
      },
      cosUploadFile(file) {
        const that = this
        that.percentage ++;
        uploadFile({path:this.path, file:file}, (err, data) => {
          if (err) {
            console.log(err)
          } else {
            that.url=data.fid
          }
        }, (progressData) => {
          // this.uploadStatus = 1
          if(progressData>0) {
            that.percentage = progressData * 100
          }
          if (progressData * 100 == 100) {
            that.$mResToast({
              type:'success',
              msg:'上传成功',
              duration:3000,
              isIcon:true,
            });
            setTimeout(() => {
              that.toStudy()
              that.percentage = 0
            }, 1500);
          }
        })
      },
      toStudy(){
        var _this = this;
        this.post('/reportFile/reportSave',{eventId:_this.event.eventId,fileName:_this.fileName,url:_this.url},(data)=>{
          _this.getUploaded();
        })
      },
      // handleChange(file){
      //   console.log(file);
      //   this.fileName = file.name;
      //   this.file = file;
      //   this.canUpload = true;
      //   console.log(this.$refs.newupload);
      //   this.uploadComponent = this.$refs.newupload;
      // },
      //上传文件
      async handleChange(file) {
        this.$refs.newupload.submit();
        if(!this.canUpload) {
          return false;
        }
        // const bo = await this.$confirm('上传后无法修改, 是否继续?', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'info'
        //   }).then(() => {
        // console.log('确定上传')
        //  this.fileName = file.name;
        //  this.checkStatus = '审核中';
        //     return true;
        //   }).catch(() => {
        //     console.log('取消上传')
        //     return false;
        //   })
        // if (bo) {
        //this.$refs.newupload.submit();
        //  this.canUpload = false;
        // }
      },
      beforeUpload(file){
        var _this = this;
        // console.log(file)
        let extension = file.name.substring(file.name.lastIndexOf('.')+1);
        console.log(extension);
        const isLt20M = file.size /( 1024 * 1024 * 20) < 1;
        if (!isLt20M) {
          _this.$mResToast({
            type:'error',
            msg:'请选择小于20M的文件重新上传！',
            duration:3000,
            isIcon:true,
          });
          return false;
        }

        if(_this.config.fileExt.split(",").indexOf(extension)>-1) {
          this.fileName = file.name;
          this.checkStatus = '审核中';
          this.canUpload = false;
          return true;
        }else{
          _this.$mResToast({
            type:'error',
            msg:'上传失败，请选择格式为'+_this.config.fileExt+'的文件上传',
            duration:3000,
            isIcon:true,
          });
          return false;
        }




        // if(!this.canUpload){
        //   return false;
        // }

        // fd.append('eventId',this.event.eventId);//传其他参数
        // this.post('/reportFile/fileUpload',fd,(res)=>{
        // console.log(res);
        // _this.newSubmitForm();
        // })
      },
    }
  }
</script>
<style scoped>
  .content{
    width: 15rem;
    margin: 0.95rem auto;
    padding-bottom: 0.84rem;
  }
  .icon{
    width: 1.35rem;
    height: 1.35rem;
    margin: 01rem auto 0.5rem auto;
  }
  .icon img{
    width: 100%;
    height: 100%;
    float: left;
  }
  .title{
    width: 11rem;
    margin: 0 auto;
    font-size: 0.33rem;
    color: #404040;
    margin-bottom: 0.2rem;
  }
  .input{
    width: 4.8rem;
    min-height: 2.91rem;
    border: 0.02rem solid #8b8b8b;
    border-radius: 0.2rem;
    margin: 0.4rem auto;
    cursor: pointer;
    text-align:center;
  }

  .upload-file{
    float: left;
    height: 2.91rem;
    width: 100%;
  }

  .upload-file >>> .el-upload{
    display: block;
    margin: 0 auto;
  }
  >>> .el-upload-dragger{
    border: none;
    width: 100%;
    height: 2.86rem;
    border-radius: 0.2rem;
  }


  .input .upload{
    display: block;
    margin: 0.47rem auto;
  }
  .input .doc{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 1.8rem;
    text-align: center;
  }
  .input .doc img{
    width: 0.41rem;
    height: 0.45rem;
    margin:0 0.21rem;
  }
  .input .doc span{
    font-size: 0.25rem;
    color: #7f7f7f;
    max-width: 3.6rem;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:3;
  }
  .input .tip{
    font-size: 0.25rem;
    color: #404040;
    display: block;
    text-align: center;
  }
  .input .tips{
    font-size: 0.21rem;
    color: #8b8b8b;
    display: block;
    text-align: center;
    margin-top: 0.08rem;
  }
  .input .sure{
    font-size: 0.25rem;
    color: #404040;
    display: block;
    text-align: center;
    margin-bottom: 0.2rem;
  }
  .input .again{
    font-size: 0.21rem;
    color: #2b73cc;
    display: block;
    width: 1rem;
    text-align: center;
    margin: 0 auto;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }
  .sumup_ok{
    width: 3.81rem;
    height: 3.9rem;
    display: block;
    margin: 0.5rem auto;
  }
  .btn{
    width: 1.38rem;
    height: 0.59rem;
    margin: 0 auto;
    background-color: #0073d3;
    color: #fff;
    font-size: 0.25rem;
    text-align: center;
    line-height: 0.59rem;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/Sumup.vue